







































import {
    defineComponent,
    PropType,
    computed,
    onMounted,
} from "@nuxtjs/composition-api";
import { SfQuantitySelector, SfButton } from "~/storefrontUI/components";
import AddToWishlist from "components/wishlist/AddToWishlist.vue";
import type { Product } from "@wemade-vsf/catalog/lib/runtime/product/types";

export default defineComponent({
    name: "ProductActions",
    props: {
        showQuantity: {
            type: Boolean,
            default: true,
        },
        showAddToCart: {
            type: Boolean,
            default: true,
        },
        showWishlist: {
            type: Boolean,
            default: true,
        },
        isInWishlist: {
            type: Boolean,
            default: false,
        },
        isQuoteProduct: {
            type: Boolean,
            default: false,
        },
        qty: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        product: {
            type: Object as PropType<Product>,
            default: null,
        },
    },
    model: {
        prop: "qty",
    },
    components: {
        SfQuantitySelector,
        SfButton,
        AddToWishlist,
        PriceRequestButton: () =>
            import("components/catalog/Product/PriceRequestButton.vue"),
    },
    setup() {
        const supportsIntersection = computed(
            () => process.browser && "IntersectionObserver" in window
        );
        let navigationObserver: IntersectionObserver | null = null;

        if (process.browser && "IntersectionObserver" in window) {
            navigationObserver = new IntersectionObserver(
                (entries) => {
                    for (let entry of entries) {
                        test(entry.intersectionRatio < 1 ? "0" : "100%");
                    }
                },
                { threshold: [1] }
            );
        }

        const test = (val: string) => {
            if (process.browser && document) {
                document.documentElement.style.setProperty(
                    "--product-fixed-add-to-cart-transform",
                    val
                );
            }
        };

        onMounted(async () => {
            if (process.browser && supportsIntersection) {
                const target = document.querySelector(
                    ".product__info .product-actions"
                );

                if (target && navigationObserver) {
                    navigationObserver.observe(target);
                }
            }
        });
    },
});
